import { arrayInsert, arrayMove, arrayPop, arrayPush, arrayRemove, arrayRemoveAll, arrayShift, arraySplice, arraySwap, arrayUnshift, autofill, blur, change, destroy, focus, initialize, reset, startAsyncValidation, startSubmit, stopSubmit, stopAsyncValidation, touch, untouch } from 'redux-form';
export default {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  reset: reset,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopSubmit: stopSubmit,
  stopAsyncValidation: stopAsyncValidation,
  touch: touch,
  untouch: untouch
};